import { render, staticRenderFns } from "./ModalPreencherDadosCoordenador.vue?vue&type=template&id=e8366120&scoped=true"
import script from "./ModalPreencherDadosCoordenador.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalPreencherDadosCoordenador.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalPreencherDadosCoordenador.vue?vue&type=style&index=0&id=e8366120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8366120",
  null
  
)

export default component.exports